/** Explains why approval on this contract is restricted to a senior reviewer.
 *
 *  Shown only to reviewers who cannot lift the lock themselves. The reasons
 *  come from the gate verbatim (INV-TYPE-01 / INV-LAW-01 / INV-POL-01) so the
 *  reviewer knows what they are escalating, not just that they are blocked.
 */
import { Alert, AlertDescription } from '@/components/ui/alert';
import { ShieldAlert } from 'lucide-react';

export function SeniorLockBlockedMessage() {
  return (
    <p role="alert" className="text-xs text-destructive">
      Approving this contract requires a senior reviewer. Choose Reject or Escalate instead.
    </p>
  );
}

export function SeniorLockNotice({ reasons }: { reasons: string[] }) {
  return (
    <Alert>
      <ShieldAlert className="h-4 w-4" aria-hidden="true" />
      <AlertDescription className="space-y-1">
        <p className="font-medium">This contract can only be approved by a senior reviewer.</p>
        {reasons.length > 0 && (
          <ul className="ml-4 list-disc space-y-0.5 text-xs">
            {reasons.map((reason) => <li key={reason}>{reason}</li>)}
          </ul>
        )}
        <p className="text-xs">
          You can still reject it, or escalate it so a senior reviewer picks it up.
        </p>
      </AlertDescription>
    </Alert>
  );
}
